import { createPortal } from "react-dom";
import { deleteArticle } from "./CommonFunc";
import { useContext } from "react";
import { AppContext } from "../Context/AppContext";
function DeleteArticle(props) {
	const { theme } = useContext(AppContext);
	const rawContent = props.content.find(
		(element) => element.ID === props.currentContentId
	);
	const id = rawContent?.ID;
	const parentId = rawContent?.ID_PAR;
	const header = rawContent?.HEADER;
	const handleDelete = () => {
		deleteArticle(id).then(() =>
			props.deleteDialogVisible({ open: false, parentId: parentId })
		);
	};
	return createPortal(
		<div
			className='delete-article-wrapper'
			color={theme.color}
			style={{
				fontSize: `${18 * theme.fontMultiplier}px`,
			}}
		>
			<div className='delete-article'>
				<div
					style={{ color: "var(--font-color)" }}
				>{`Вы действительно хотите удалить статью "${header}"?`}</div>
				<div
					style={{ color: "var(--font-color)" }}
				>{`Предуприжение: При удалении будут удалены дочернии элементы.`}</div>
				<div className='button-block'>
					<div className='create-button' onClick={() => handleDelete()}>
						Удалить
					</div>
					<div
						className='close-button'
						onClick={() => props.deleteDialogVisible({ open: false })}
					>
						Закрыть
					</div>
				</div>
			</div>
		</div>,
		document.getElementById("deleteArticle")
	);
}

export default DeleteArticle;
